import {AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, QueryList, ViewChildren} from '@angular/core';
import {ChecklistItem, ChecklistModel, TaskReadOnlyStatus} from '../../models/task-manager.model';
import {CommandService} from '@core/services/command.service';
import {AddChecklistCommand, ChangeChecklistOrderCommand, UpdateChecklistCommand} from '../../commands/task-manager.command';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {select, Store} from '@ngrx/store';
import {BehaviorSubject, Subject} from 'rxjs';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {take, takeUntil} from 'rxjs/operators';
import {QueryProvider} from '@shared/queries/query-provider';
import {DialogService} from '@shared/services/dialog-service';
import {TimeZoneService} from '@core/services/time-zone.service';
import {MatDialog} from '@angular/material/dialog';
import {FileDialogComponent} from '../../../file-manager/component/file-dialog/file-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';
import {TaskManagerApiService} from '../../services/task-manager-api.service';
import {TicketFollower, TicketManager, TicketOwner} from '../../constants/task-manager.constants';
import {UserInfo} from '@shared/models/user-info.model';
import {SecurityState} from '@shared/store/reducers/security.reducer';
import {getUserInfo} from '@shared/store/selectors/security.selector';
import {SnackBarService} from '@core/services/snack-bar.service';
import {TaskManagerQuery} from '@features/task-manager/helpers/task-manager.query';
import {TaskManagerConfig} from '@features/task-manager/helpers/task-manager.config';
import {GraphQLService} from '@core/services/graphql.service';
import {GraphqlContentScope} from '@shared/models/graphql-content-scope.model';
import {RootDynamicComponentHelper} from '@shared/helpers/root-dynamic-component-helper';
import {PlatformSidebarState} from '@shared/components/platform-sidebar/store/platform-sidebar.reducer';
import {getRightSideBarIsFolded} from '@shared/components/platform-sidebar/store/platform-sidebar.selector';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {PlatformQueryService} from '@core/services/platform-query.service';
import {PlatformQuery} from '@shared/models/platform-query/platform-query';
import {PlatformCommand} from '@shared/commands/command-base';
import {IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {Router} from '@angular/router';

@Component({
    standalone: false,
    selector: 'particle-task-checklist',
  templateUrl: './task-checklist.component.html',
  styleUrls: ['./task-checklist.component.scss']
})
export class TaskChecklistComponent implements OnInit, AfterViewInit, OnDestroy {
  checklists: ChecklistModel[];
  checklists$: any;
  @Input() dynamicData: any;
  @Input() data: any;
  card: any;
  overallProgressNumber = 0;
  unsubscribe$: Subject<void>;
  userInfo: UserInfo;
  key = 'ChecklistKey';
  showAllCheckBox = true;

  hasOwnerAndManagerPermission: boolean;
  hasOwnerManagerAssigneeAndReviewerPermission: boolean;
  checkListScroll: boolean;
  invalidatedRightSideComponentData$: BehaviorSubject<any> = new BehaviorSubject(null);
  @ViewChildren('checkItemDiv') checkItemDivs: QueryList<ElementRef>;
  isFolded: boolean;
  saveCommand: PlatformCommand;

  constructor(private commandService: CommandService,
              private router: Router,
              private queryStore: Store<IQueryState>,
              private dialogService: DialogService,
              private timeZoneService: TimeZoneService,
              private fuseSpashScreenService: FuseSplashScreenService,
              protected dialog: MatDialog,
              private taskManagerApiService: TaskManagerApiService,
              private securityStore: Store<SecurityState>,
              private snackBarService: SnackBarService,
              private graphQLService: GraphQLService,
              private platformSidebarStore: Store<PlatformSidebarState>,
              private platformQueryService: PlatformQueryService
  ) {
    this.checklists = [];
    this.unsubscribe$ = new Subject<void>();
  }

  ngOnInit() {
    this.showAllCheckBox = !this.router.url.includes('task-manager');
    this.platformSidebarStore
      .pipe(
        select(getRightSideBarIsFolded),
        takeUntil(this.unsubscribe$)
      ).subscribe(res => {
      this.isFolded = res;
    });
    if ( this.data.isOpenFromRightPanel === true) {
      this.platformLinkCheckListHandle();
      this.invalidatedRightSideComponentData$.pipe(takeUntil(this.unsubscribe$)).subscribe(data => {
        // console.log('checklist data:', data);
        if (data) {
          this.data = data;
          this.platformLinkCheckListHandle();
        }
      });
      return;
    }
    this.startPrecess();
  }

  saveAsPlatformLink() {
    this.fuseSpashScreenService.show();
    let handler = null;
    if (this.data.currentPlatformLink && this.data.currentPlatformLink.fieldValues && this.data.currentPlatformLink.fieldValues['Handler']) {
      handler = RootDynamicComponentHelper.getComponent(this.data.currentPlatformLink.fieldValues['Handler']);
    }
    if (this.saveCommand.fieldValues['CommandHandler']) {
      const commandHandler = RootDynamicComponentHelper.getComponent(this.saveCommand.fieldValues['CommandHandler']);
      if (commandHandler) {
        commandHandler.executeCommand(this.saveCommand, handler);
        return;
      }
    }
    this.commandService.executePlatformCommand(this.data.currentPlatformLink.rightPanel.commands['Save']).pipe(take(1)).subscribe(x => {
      this.fuseSpashScreenService.hide();
      handler?.invalidateSubject.invalidate('Refresh');
      console.log('rightPanel.command', x);
    });
  }

  ngAfterViewInit() {
    this.checkItemDivs.changes.subscribe(() => {
      if (this.checkItemDivs && this.checkItemDivs.last && this.checkListScroll) {
        this.checkItemDivs.last.nativeElement.scrollIntoView();
      }
    });
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    // this.platformSidebarStore.dispatch(new SetCurrentRightSideComponentAction(null));
    // this.platformSidebarStore.dispatch(new SetCurrentRightSideBarFoldOrNotAction(true));
  }

  addItem(checklist: ChecklistModel) {
    this.resetEditing();
    checklist.isAddingNewItem = true;
  }

  startEditItem(checkItem: ChecklistItem) {
    if (!this.canEditCheckList()) {
      return;
    }
    this.resetEditing();
    checkItem.isEditing = true;
  }

  startChecklistEdit(checklist: ChecklistModel) { // checkList title edit
    if (!this.canEditCheckList()) {
      return;
    }
    this.resetEditing();
    checklist.isEditing = true;
  }

  canEditCheckList(): boolean {
    const taskReadOnlyStatus: TaskReadOnlyStatus = (this.data.input) ?  this.data.input['taskReadOnlyStatus'] : null;
    if (taskReadOnlyStatus && taskReadOnlyStatus.CheckList['CanEditCheckList']) {
      return false;
    }
    return true;
  }

  addChecklist() {
    this.checkListScroll = true;
    if (this.isOpenedOnAWorkflowNode()) {
      this.addWorkflowNodeChecklist();
      return;
    }
    const command = new AddChecklistCommand(this.card.id);
    command.scope = this.card.scopeInt;
    this.commandService.executeCommand(command).pipe().subscribe(state => {
      this.invalidate();
    });
  }

  /** A workflow node's opener passes its workflow and node: its task lives only on the Flow server. */
  private isOpenedOnAWorkflowNode(): boolean {
    const parameters = this.data.input?.parameters;
    return !!(parameters?.taskApi && parameters?.flowId && parameters?.nodeId);
  }

  private addWorkflowNodeChecklist() {
    const parameters = this.data.input.parameters;
    const command = new PlatformCommand('AddFlowNodeChecklistCommand', parameters.taskApi);
    command.fieldValues['TicketId'] = this.card.id;
    command.fieldValues['FlowId'] = parameters.flowId;
    command.fieldValues['NodeId'] = parameters.nodeId;
    this.commandService.executePlatformCommand(command).pipe().subscribe(state => {
      this.invalidate();
    });
  }

  checklistTitleChanged(checklist: ChecklistModel, $event: any) {
    checklist.title = $event.text;
    this.resetEditing();
    const command = this.getUpdateChecklistCommand(checklist);
    command.scope = this.card.scopeInt;
    this.commandService.executePlatformCommand(command).pipe().subscribe(state => {
      this.invalidate();
    });
  }

  private getUpdateChecklistCommand(checklist: ChecklistModel = null, checkAll: boolean = false, uncheckAll: boolean = false): PlatformCommand {
    if (this.data.currentPlatformLink?.additionalCommands['UpdateChecklistCommand']) {
      const command = this.data.currentPlatformLink.additionalCommands['UpdateChecklistCommand'];
      command.fieldValues = {
        ...command.fieldValues,
        'Checklist': checklist,
        'CheckAll': checkAll,
        'UncheckAll': uncheckAll
      };
      return command;
    }
    const updateChecklistCommand = new PlatformCommand('UpdateChecklistCommand', 'TaskManagerApi');
    updateChecklistCommand.scope = this.card.scopeInt;
    if (this.data.input.parameters?.taskApi) {
      updateChecklistCommand.api = this.data.input.parameters?.taskApi;
    }
    if (this.data.currentPlatformLink?.rightPanel.data.TaskApi) {
      updateChecklistCommand.api = this.data.currentPlatformLink?.rightPanel.data.TaskApi;
    }
    updateChecklistCommand.fieldValues['Checklist'] = checklist;
    updateChecklistCommand.fieldValues['CheckAll'] = checkAll;
    updateChecklistCommand.fieldValues['UncheckAll'] = uncheckAll;
    return updateChecklistCommand;
  }

  addItemToChecklist(checklist: ChecklistModel, $event: any) {
    if (this.isDuplicateItemTitleExist(checklist, $event.text.trim())) {
      this.snackBarService.showError('The item already exists.');
      return;
    }
    const item = new ChecklistItem();
    item.title = $event.text.trim();
    item.type = $event.type ? $event.type : 'Text';
    item.isCompleted = false;
    item.isEditing = false;
    checklist.items.push(item);
    this.resetEditing();
    const command = this.getUpdateChecklistCommand(checklist);
    command.scope = this.card.scopeInt;
    this.commandService.executePlatformCommand(command).pipe().subscribe(state => {
      this.invalidate();
    });
  }

  isDuplicateItemTitleExist(checklist: ChecklistModel, title: string): boolean {
    return checklist.items.filter(item => item.title === title.trim()).length > 0;
  }

  updateChecklistItem(checklist: ChecklistModel, checkItem: ChecklistItem, $event) {
    if (checkItem.title === $event.text.trim()) {
      this.resetEditing();
      return;
    }
    if (this.isDuplicateItemTitleExist(checklist, $event.text.trim())) {
      this.snackBarService.showError('The item already exists.');
      return;
    }
    checkItem.title = $event.text.trim();
    this.resetEditing();
    const command = this.getUpdateChecklistCommand(checklist);
    command.scope = this.card.scopeInt;
    this.commandService.executePlatformCommand(command).pipe().subscribe(state => {
      this.invalidate();
    });
  }

  updateCheckedState(checklist: ChecklistModel, checkItem: ChecklistItem, $event) {
    checkItem.isCompleted = $event.checked;
    this.resetEditing();
    const command = this.getUpdateChecklistCommand(checklist);
    command.scope = this.card.scopeInt;
    this.commandService.executePlatformCommand(command).pipe().subscribe(res => {
      if (res.fieldValues['Refresh'] === true && this.data.currentPlatformLink?.fieldValues['Handler']) {
        const handler = RootDynamicComponentHelper.getComponent(this.data.currentPlatformLink.fieldValues['Handler']);
        handler.invalidateSubject.invalidate('Refresh');
        return ;
      }
      this.invalidate();
    });
  }

  resetEditing() {
    this.checklists.forEach(ch => {
      ch.isEditing = false;
      ch.isAddingNewItem = false;
      ch.items.forEach(item => {
        item.isEditing = false;
      });
    });
  }

  getPercentageCompleted(checklist: ChecklistModel) {
    return Math.round(100 * checklist.checkedItemCount / checklist.items.length);
  }

  removeCheckItem(checklist: ChecklistModel, checkItem: ChecklistItem) {
    this.dialogService.showYesNoDialog('Confirm Remove', 'Are you sure you want to remove checklist item?')
      .subscribe(state => {
        if (state && state.action === 'OK') {
          const index = checklist.items.indexOf(checkItem);
          if (index >= 0) {
            checklist.items.splice(index, 1);
          }
          this.resetEditing();
          const command = this.getUpdateChecklistCommand(checklist);
          command.scope = this.card.scopeInt;
          this.commandService.executePlatformCommand(command).pipe().subscribe(response => {
            this.invalidate();
          });
        }
      });
  }

  convertToSubTask(checklist: ChecklistModel, checkItem: ChecklistItem) {
    this.resetEditing();
    checkItem.type = 'SubTask';
    const command = this.getUpdateChecklistCommand(checklist);
    command.scope = this.card.scopeInt;
    this.commandService.executePlatformCommand(command).pipe().subscribe(response => {
      this.invalidate();
    });
  }

  convertToAttachment(checklist: ChecklistModel, checkItem: ChecklistItem) {
    this.resetEditing();
    checkItem.type = 'Attachment';
    const command = this.getUpdateChecklistCommand(checklist);
    command.scope = this.card.scopeInt;
    this.commandService.executePlatformCommand(command).pipe().subscribe(response => {
      this.invalidate();
      this.addAttachment(checklist, checkItem);
    });
  }

  convertToLink(checklist: ChecklistModel, checkItem: ChecklistItem) {
    this.resetEditing();
    checkItem.type = 'Link';
    const command = this.getUpdateChecklistCommand(checklist);
    command.scope = this.card.scopeInt;
    this.commandService.executePlatformCommand(command).pipe().subscribe(response => {
      this.invalidate();
      this.addLink(checklist, checkItem);
    });
  }

  removeChecklist(checklist: ChecklistModel) {
    this.dialogService.showYesNoDialog('Confirm Remove', 'Are you sure you want to remove checklist?').subscribe(state => {
      if (state && state.action === 'OK') {
        checklist.isDeleted = true;
        this.resetEditing();
        const command = this.getUpdateChecklistCommand(checklist);
        command.scope = this.card.scopeInt;
        this.commandService.executePlatformCommand(command).pipe().subscribe(response => {
          this.invalidate();
        });
      }
    });
  }

  moveChecklist(checklist: ChecklistModel, moveDirection: number) {
    this.resetEditing();
    const idx = this.checklists.indexOf(checklist);
    console.log(idx);
    if (moveDirection === 1) {
      if (idx > 0) {
        [this.checklists[idx], this.checklists[idx - 1]] = [this.checklists[idx - 1], this.checklists[idx]];
      }
    } else {
      if (idx < this.checklists.length - 1) {
        [this.checklists[idx], this.checklists[idx + 1]] = [this.checklists[idx + 1], this.checklists[idx]];
      }
    }
    console.log(this.checklists);
    const checklistIds = this.checklists.map(c => c.id);
    // command.ticketId, checklistIds
    /*const command = new UpdateChecklistCommand(checklist);
    command.scope = this.card.scopeInt;
    this.commandService.executeCommand(command).pipe().subscribe(response => {
      this.invalidate();
    });*/
    const command = new ChangeChecklistOrderCommand(checklistIds, this.card.id);
    command.scope = this.card.scopeInt;
    this.commandService.executeCommand(command).pipe().subscribe(response => {
      this.invalidate();
    });
  }

  moveCheckItem(checklist: ChecklistModel, checkItem: ChecklistItem, moveDirection: number) {
    this.resetEditing();
    const idx = checklist.items.indexOf(checkItem);
    if (moveDirection === 1) {
      if (idx > 0) {
        [checklist.items[idx], checklist.items[idx - 1]] = [checklist.items[idx - 1], checklist.items[idx]];
      }
    } else {
      if (idx < checklist.items.length - 1) {
        [checklist.items[idx], checklist.items[idx + 1]] = [checklist.items[idx + 1], checklist.items[idx]];
      }
    }
    const command = this.getUpdateChecklistCommand(checklist);
    command.scope = this.card.scopeInt;
    this.commandService.executePlatformCommand(command).pipe().subscribe(response => {
      this.invalidate();
    });
  }

  openChecklistItemSubTask(checkItem) {
    if (checkItem.taskInfo) {
      const card = {
        id: checkItem.taskInfo.ticketId,
        boardId: this.data.input.board.id,
        name: checkItem.taskInfo.displayId + '-' + checkItem.taskInfo.title,
        displayId: checkItem.taskInfo.displayId,
        scopeInt: this.data.input.card['scopeInt'],
        parentTicket: this.data.input.card
      };
      this.navigate(card);
    }
  }

  navigate(card: any) {
    const result = {
      action: 'Redirect',
      board: this.data.input.board,
      card: card
    };
    const dialogRef = this.data['dialogRef'];
    dialogRef.close(result);
  }

  addAttachment(checklist: ChecklistModel, checklistItem: ChecklistItem) {
    const dialogRef = this.dialog.open(FileDialogComponent, {
      minWidth: '600px',
      maxWidth: '600px',
      data: {
        itemsUrlIndex: 1,
        type: 'SharedDrives',
        folderId: '',
        driveId: '',
        isFileSelector: true
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.unsubscribe$)).subscribe((result: any) => {
      if (!result || !result.id) {
        return;
      }

      const item = checklist.items.find(cli => cli.id === checklistItem.id);
      item.attachment = {
        attachmentId: result.id,
        attachmentTitle: result.cells.Name.displayText,
        attachmentType: 'FileEntry',
        attachedBy: '',
        attachedDate: this.timeZoneService.getUTCDateWithoutTime(new Date())
      };
      this.resetEditing();
      const command = this.getUpdateChecklistCommand(checklist);
      command.scope = this.card.scopeInt;
      this.commandService.executePlatformCommand(command).pipe().subscribe(state => {
        this.invalidate();
      });
    });
  }

  addLink(checklist: ChecklistModel, checklistItem: ChecklistItem) {
    const dialogModel = DialogModel.create('Add Link', 'AddLinkDialogComponent', {
      displayText: checklistItem.checklistItemLink ? checklistItem.checklistItemLink.displayText : '',
      url: checklistItem.checklistItemLink ? checklistItem.checklistItemLink.url : ''
    });
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(state => {
      if (state && state.action === 'OK') {
        const item = checklist.items.find(cli => cli.id === checklistItem.id);
        item.checklistItemLink = {
          displayText: state.data.input.displayText,
          url: state.data.input.url
        };
        this.resetEditing();
        const command = this.getUpdateChecklistCommand(checklist);
        command.scope = this.card.scopeInt;
        this.commandService.executePlatformCommand(command).pipe().subscribe(response => {
          this.invalidate();
        });
      }
    });
  }

  openLink(url: string) {
    url = url.match(/^http[s]?:\/\//) ? url : 'http://' + url;
    window.open(url, '_blank');
  }

  private startPrecess() {
    if (this.dynamicData && this.dynamicData.card) {
      this.checkListScroll = false;
      this.card = this.dynamicData.card;
      this.securityStore.pipe(select(getUserInfo)).subscribe(state => this.userInfo = state);
      this.hasOwnerAndManagerPermission = this.hasPermissions();
      this.hasOwnerManagerAssigneeAndReviewerPermission = this.hasPermissions(true);
      this.invalidate();
    }
  }

  private checklistQuery(card: any): PlatformQuery {
    const query = new PlatformQuery();
    query.api = 'TaskManagerApi';
    if (this.data.input.parameters?.taskApi) {
      query.api = this.data.input.parameters?.taskApi;
    }
    if(this.data.currentPlatformLink?.rightPanel.data.TaskApi) {
      query.api = this.data.currentPlatformLink?.rightPanel.data.TaskApi;
    }
    query.name = 'ChecklistsQuery';
    query.fieldValues = {
      TicketId: card.id,
      Scope: card.scopeInt
    };
    return query;
  }

  private platformLinkCheckListHandle() {
    this.saveCommand = this.getSaveCommand();
    const selectedTaskQuery = TaskManagerQuery.getSelectedTask(this.data.currentPlatformLink?.rightPanel.data.TaskInfo.ticketId, GraphqlContentScope.getScope(this.data.currentPlatformLink?.rightPanel.data.TaskInfo.boardScope));
    const api = this.data.currentPlatformLink?.rightPanel.data.TaskApi ? this.data.currentPlatformLink?.rightPanel.data.TaskApi : TaskManagerConfig.TaskManagerApiKey;
    this.graphQLService.executePostRequest(api, selectedTaskQuery).subscribe((selectedTicket: any) => {
      if (selectedTicket) {
        this.dynamicData = {};
        this.dynamicData.card = selectedTicket.data.ticketWithBoard;
        this.hasOwnerAndManagerPermission = false;
        this.data.input = {
          board: selectedTicket.data.ticketWithBoard.board,
          taskReadOnlyStatus: {CheckList: {CanEditCheckList: this.data.currentPlatformLink?.rightPanel.data.IsReadOnly}},
          card: this.dynamicData.card
        };
        this.startPrecess();

        // const kanbanTicket = this.data.currentPlatformLink.rightPanel.data.TaskInfo.ticketId;
        //
        // this.dynamicData = {
        //   card: {
        //     id             : kanbanTicket.id,
        //     scopeInt       : kanbanTicket.scope,
        //     permissionLevel: kanbanTicket.permissionLevel
        //   }
        // };
        // this.data.input = {
        //   boarrd            : {id: kanbanTicket.boardId},
        //   taskReadOnlyStatus: this.data.currentPlatformLink.rightPanel.data['CanEditCheckList'] === true ? true : false,
        //   card              : this.dynamicData.card
        // };

      }
    }, (err) => {
      console.log(err);
    });


  }

  getSaveCommand(){
    let saveCommand = this.data.currentPlatformLink?.rightPanel.commands['Save'];
    let item = this.data.currentPlatformLink?.breadcrumbBar?.items?.find(item => item.id === "Default");
    let command = item?.commands?.find(command => command.name === "MarkAsCompletedCommand");
    if(command){
      saveCommand = command;
    }
    return saveCommand;
  }

  private invalidate() {
    // QueryProvider.invokeQuery(this.queryStore, this.key, {
    //   '[TASK_ID]': this.card.id,
    //   '[SCOPE]': this.card.scopeInt
    // });
    this.checklists$ = this.platformQueryService.executeQuery(this.checklistQuery(this.card));
    this.checklists$.pipe(takeUntil(this.unsubscribe$)).subscribe(res => {
      this.checklists = res.fieldValues['Checklists'];
      let overallProgress = 0;
      this.checklists.forEach(cl => {
        const progress = this.getPercentageCompleted(cl);
        overallProgress += progress;
        cl['progress'] = progress;
      });
      this.overallProgressNumber = overallProgress / this.checklists.length;
      if (!this.checklists || this.checklists.length === 0) {
        this.addChecklist();
      }
    });
  }

  private hasPermissions(shouldCheckMore?: boolean): boolean {
    const permissionType = this.dynamicData.card.permissionLevel;
    if (shouldCheckMore) {
      return (TicketOwner <= permissionType && permissionType <= TicketFollower);
    }
    return (permissionType === TicketOwner || permissionType === TicketManager);
  }

  onCheckAll($event: any, checklist: any) {
    const command = this.getUpdateChecklistCommand(checklist, $event.checked, $event.checked === false);
    this.commandService.executePlatformCommand(command).pipe(takeUntil(this.unsubscribe$)).subscribe(res => {
      if (res.fieldValues['Refresh'] === true && this.data.currentPlatformLink?.fieldValues['Handler']) {
        const handler = RootDynamicComponentHelper.getComponent(this.data.currentPlatformLink.fieldValues['Handler']);
        handler.invalidateSubject.invalidate('Refresh');
        return ;
      }
      this.invalidate();
    });
  }
}
